module.exports = {
    resourcesTitle: '行业资源',
    marketreports: '市场报告',
    appanalysis: 'APP分析报告',
    competitoranalysis: '竞品分析报告',
    appDataMarket: '商店数据搜索',
    pleaseInputPKG: '请输入PKG ID',
    pleaseSelectYourPlatform: '请选择平台',
    pleasaEnterFiltersCountry: '请输入要查询的国家',
    countryOptional: '国家',
    Local:'本地媒体营销',
    Programmatic:'程序化营销',
    Aggregator:'聚合媒体营销',
    KOL:'网红营销',
    MKT:'',
    Service:'',
    ADN:'ADN服务',
    AggregatorS:'聚合媒体营销',
    Report:''
}



// WEBPACK FOOTER //
// ./src/i18n/modules/resources/zh-cn.js